export const listProductsInPreparationPage = {
  title: "Produtos - Preparando",
  product: "Produto",
  quantity: "Quantidade",
  status: "Estado Atual do Pedido",
  id: "Id",
};
